/* global Foundation  */

import Vue from 'vue'
import $ from 'jquery'
export default Vue.extend({
  name: 'joi-form-error-text',
  template: '<p class="error-text" role="error-information">{{message}}</p>',
  props: ['for', 'path', 'message'],
  isFormError: true,
  data () {
    return {
    }
  },
  methods: {
    show: function () {
      Foundation.Motion.animateIn(this.$el, 'fade-in')
    },
    hide: function () {
      $(this.$el).hide()
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/inputs/joi-form-error-text.js